export const SUSPENSION_LEVELS = {
  COURSE: 'course',
  FUTURE_LESSONS: 'future_lessons',
  PLATFORM: 'platform',
};

export const SUSPENSION_LABELS = {
  [SUSPENSION_LEVELS.COURSE]: 'Course suspended',
  [SUSPENSION_LEVELS.FUTURE_LESSONS]: 'Future lessons suspended',
  [SUSPENSION_LEVELS.PLATFORM]: 'Platform suspended',
};

export const getSuspensionLabel = (level) =>
  SUSPENSION_LABELS[level] || 'Suspended';

export const isPlatformSuspended = (profile = {}) => {
  const level = profile.suspensionLevel || profile.accessSuspensionLevel;
  return Boolean(
    profile.accessSuspended ||
      level === SUSPENSION_LEVELS.PLATFORM ||
      (profile.status === 'suspended' && level !== SUSPENSION_LEVELS.COURSE && level !== SUSPENSION_LEVELS.FUTURE_LESSONS),
  );
};

export const getCourseSuspensions = (...profiles) =>
  profiles.reduce((merged, profile) => {
    const courseSuspensions = profile?.courseSuspensions || {};
    Object.entries(courseSuspensions).forEach(([key, value]) => {
      if (value) merged[key] = value;
    });
    return merged;
  }, {});

export const getCourseSuspension = ({ courseId, ...profiles }) => {
  const suspensions = getCourseSuspensions(
    profiles.user,
    profiles.student,
    profiles.enrollment,
    profiles.course,
  );
  return (
    suspensions[courseId] ||
    Object.values(suspensions).find(
      (item) => String(item?.courseId || '') === String(courseId || ''),
    ) ||
    null
  );
};

const isFutureDate = (value) => {
  if (!value) return false;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return date > today;
};

export const isLessonRestrictedBySuspension = (suspension, lesson) => {
  if (!suspension) return false;
  if (suspension.level === SUSPENSION_LEVELS.COURSE) return true;
  if (suspension.level !== SUSPENSION_LEVELS.FUTURE_LESSONS) return false;
  return Boolean(
    lesson?.isUpcoming ||
      isFutureDate(lesson?.scheduledDate) ||
      isFutureDate(lesson?.scheduledDateIso) ||
      isFutureDate(lesson?.date) ||
      (!lesson?.isAvailable && !lesson?.completed),
  );
};

export const suspensionMessage = (suspension, fallbackCourseName = 'this course') => {
  if (!suspension) return '';
  const courseName = suspension.courseName || fallbackCourseName;
  const reason = suspension.reason ? ` Reason: ${suspension.reason}` : '';
  if (suspension.level === SUSPENSION_LEVELS.FUTURE_LESSONS) {
    return `Access to future lessons in ${courseName} is temporarily suspended.${reason}`;
  }
  if (suspension.level === SUSPENSION_LEVELS.PLATFORM) {
    return `Your platform access is temporarily suspended.${reason}`;
  }
  return `Access to ${courseName} is temporarily suspended.${reason}`;
};
